import anime from 'animejs/lib/anime.es.js'

export default (context, inject) => {
    inject('anime', anime)
}
